

const Header = () => {
  return (
    <div>
        <h2>React Expense Tracker</h2>
    </div>
  )
}

export default Header
